import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { OrderCartShowtime } from './showtime';
const b = bemClassBuilder('v-order-cart-showtime-list');
export const OrderCartShowtimeList = observer(props => {
    const { orderShowtimes } = props;
    if (orderShowtimes.length === 0)
        return null;
    return (_jsx("ul", Object.assign({ className: b.block() }, { children: orderShowtimes.map(showtime => (_jsx(OrderCartShowtime, { orderShowtime: showtime }, showtime.showtimeId))) })));
});
OrderCartShowtimeList.displayName = 'OrderCartShowtimeList';
